export default __webpack_public_path__ + "static/media/goshoppi5.5ba9d398.png";